import React from 'react';
import { ScrollLink } from "react-scroll";
import {Link} from "react-router-dom";
import '../../../styles/tutorial archive/Themes.css';

// Images
const Images = {
    textcolors: require("../../../Assets/Tutorials/Themes Tutorial/Page 3 - Game.polybeatsconfig/TextColors.png"),

    hud: require("../../../Assets/Tutorials/Themes Tutorial/Page 3 - Game.polybeatsconfig/HUD.png"),

    pause_menu: require("../../../Assets/Tutorials/Themes Tutorial/Page 3 - Game.polybeatsconfig/PauseMenu.png"),

    results_menu_layer1: require("../../../Assets/Tutorials/Themes Tutorial/Page 3 - Game.polybeatsconfig/ResultsMenu/results_layer1.png"),
    results_menu_layer2: require("../../../Assets/Tutorials/Themes Tutorial/Page 3 - Game.polybeatsconfig/ResultsMenu/results_layer2.png"),

};

const otherAssets = {
    square: require("../../../Assets/Website Pack/Square.png"),
}

export default function gameMenu() {
    return (
        <div className="about-frame">
            <div id="about">
                <p>Game.polybeatsconfig (file)</p>
            </div>
            <span className="normal-text">
                    This file controls colors and variables of some things inside the actual game scenes, and Results scene.
                <br></br>
                A majority of this stuff shouldn't change, but of course new environments may not be seamlessly Theme-agnostic (work with all Themes).
               </span>
            <div className="about-leftalign">
                <br></br>
                <br></br>
                <div className="about-leftalign">
                    <p><br/><br/>TABLE OF CONTENTS</p>

                    {/* Table of Contents */}


                    <ul className="toc">
                        <li><a href="#text-colors">Text Colors</a></li>
                        <li><a href="#hud">Gameplay HUD</a></li>
                        <li><a href="#pause-menu">Pause Menu</a></li>
                        <li><a href="#results-menu">Results Menu</a></li>
                    </ul>

                </div>


                {/* Sections to jump to */}
                <div id="game.polybeatsconfig" className="sectionFormatting">
                    <br></br>

                    <div id="text-colors" className="sectionFormatting">
                        <h2>"TextColors"</h2>
                        <p>This is an assortment of all the text colors inside the game scene.
                        </p>
                        <div className="leftright-textimage-align">
                            <img
                                src={Images.textcolors}
                                style={{height: "293px", width: "520px"}}
                                alt="Custom Menu.png!"
                            />
                            <h3>"The Core" Environment (default).</h3>
                        </div>

                        <div className="property-array-align">
                            <div>
                                <h4>[1]</h4>
                                <h3>Autoplay_TextColor</h3>
                                <p>This is the color of the text shown when the Autoplay modifier is on.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[2]</h4>
                                <h3>PlaytestMode_TextColor</h3>
                                <p>This is the color of the text that is shown when Playtesting a map from our in-game
                                    Editors.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[3]</h4>
                                <h3>Grade_TextColor</h3>
                                <p>This is the color of the letter grade given to the player.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[4]</h4>
                                <h3>Accuracy_TextColor</h3>
                                <p>This is the color of the text that shows the player's accuracy percentage.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[5]</h4>
                                <h3>ScoreLabel_TextColor</h3>
                                <p>This is the color of the text that says "SCORE".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[6]</h4>
                                <h3>Score_TextColor</h3>
                                <p>This is the color of the text that shows the player's current score.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[7]</h4>
                                <h3>ComboLabel_TextColor</h3>
                                <p>This is the color of the text that says "COMBO".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[8]</h4>
                                <h3>Combo_TextColor</h3>
                                <p>This is the color of the text that shows the player's current combo streak.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="hud" className="sectionFormatting">
                        <h2>"HUD"</h2>
                        <div className="leftright-textimage-align">
                            <img
                                src={Images.hud}
                                style={{height: "394.5px", width: "520px"}}
                                alt="Custom Menu.png!"
                            />
                            <h3>Current pieces of HUD.</h3>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[1]</h4>
                                <h3>ProgressBar_FillColor</h3>
                                <p>This is the color of the area the player has already played.
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#F4004F"}}> Default Color: #F4004F </span>
                                </p>
                            </div>
                            <div>
                                <h4>[2]</h4>
                                <h3>ProgressBar_BackingColor</h3>
                                <p>This is the color of the area behind the fill color. This shows the part of the song
                                    that's not been completed yet.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #626262 </span>
                                </p>
                            </div>
                            <div>
                                <h4>[3]</h4>
                                <h3>ProgressBar_TextColor</h3>
                                <p>This is the color of the text that shows how much of the song has been completed, in
                                    seconds.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="pause-menu" className="sectionFormatting">
                        <h2>"PauseMenu"</h2>
                        <div className="leftright-textimage-align">
                            <img
                                src={Images.pause_menu}
                                style={{height: "293px", width: "520px"}}
                                alt="Custom Menu.png!"
                            />
                            <h3>The Pause menu.</h3>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[1]</h4>
                                <h3>PanelColor</h3>
                                <p>This is used for the panel (the black square in the photo) that is behind the
                                    menu.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #000000 </span>
                                </p>
                            </div>
                            <div>
                                <h4>[2]</h4>
                                <h3>Pause_TextColor</h3>
                                <p>This is the color of the text that says "[PAUSE]".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="results-menu" className="sectionFormatting">
                        <h2>"ResultsMenu"</h2>
                        <div className="leftright-textimage-align">
                            <img
                                src={Images.results_menu_layer1}
                                style={{height: "293px", width: "520px"}}
                                alt="Custom Menu.png!"
                            />
                            <h3>Results Main Menu (Layer 1)</h3>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[1]</h4>
                                <h3>Background_Color</h3>
                                <p>This is used for the image behind all the stats. This is most likely gonna be FFFFFF
                                    unless you load a custom image, and needs recoloring.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[2]</h4>
                                <h3>SongName_TextColor</h3>
                                <p>This is the color of the text that shows the song's name at the top of the screen.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[3]</h4>
                                <h3>SongDifficulty_TextColor</h3>
                                <p>This is the color of the text that shows the player's chosen difficulty at the top of
                                    the screen.
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#00CFFF"}}> Default Color: #00CFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[4]</h4>
                                <h3>Statistics_BackingColor</h3>
                                <p>This is the color of the shape that holds all the stats.
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#A40035"}}> Default Color: #A40035 </span>
                                </p>
                            </div>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[5]</h4>
                                <h3>GeneralStats_TitleTextColor</h3>
                                <p>This is the color of the text that says "GENERAL STATS".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>

                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[6]</h4>
                                <h3>GeneralStats_SkillPointsLabelColor</h3>
                                <p>This is the color of the text that says "SKILL POINTS".
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#FF83D5"}}> Default Color: #FF83D5 </span>
                                </p>
                            </div>
                            <div>
                                <h4>[7]</h4>
                                <h3>GeneralStats_SkillPointsValueColor</h3>
                                <p>This is the color of the text that shows the amount of Skill Points the player earned
                                    from the Play.
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#FF83D5"}}> Default Color: #FF83D5 </span>
                                </p>
                            </div>
                            <div>
                                <h4>[8]</h4>
                                <h3>GeneralStats_ScoreLabelColor</h3>
                                <p>This is the color of the text that says "SCORE".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[9]</h4>
                                <h3>GeneralStats_ScoreValueColor</h3>
                                <p>This is the color of the text that shows the amount of score the player earned
                                    from the Play.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[10]</h4>
                                <h3>GeneralStats_NotesHitLabelColor</h3>
                                <p>This is the color of the text that says "NOTES HIT".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[11]</h4>
                                <h3>GeneralStats_NotesHitValueColor</h3>
                                <p>This is the color of the text that shows the amount of notes the player hit
                                    for the duration of the Play.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[12]</h4>
                                <h3>GeneralStats_HighestComboLabelColor</h3>
                                <p>This is the color of the text that says "HIGHEST COMBO".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[13]</h4>
                                <h3>GeneralStats_HighestComboValueColor</h3>
                                <p>This is the color of the text that shows the highest combo the player reached
                                    in the Play.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[14]</h4>
                                <h3>GeneralStats_AccuracyLabelColor</h3>
                                <p>This is the color of the text that says "NOTES HIT".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[15]</h4>
                                <h3>GeneralStats_AccuracyValueColor</h3>
                                <p>This is the color of the text that shows the average accuracy the player hit notes
                                    at,
                                    for the duration of the Play.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[16]</h4>
                                <h3>Divider_Color</h3>
                                <p>This is the color of the divider that goes vertically down the Stats page.
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#FF006C"}}> Default Color: #FF006C </span>
                                </p>
                            </div>
                            <div>
                                <h4>[17]</h4>
                                <h3>GameStats_TitleTextColor</h3>
                                <p>This is the color of the text that says "NOTE HIT STATS".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>

                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[18]</h4>
                                <h3>GameStats_PerfectLabelColor</h3>
                                <p>This is the color of the text that says "PERFECT?!".
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#00FDFF"}}> Default Color: #00FDFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[19]</h4>
                                <h3>GameStats_PerfectValueColor</h3>
                                <p>This is the color of the text that shows the amount of notes the player hit, and got
                                    a "PERFECT" judgement, on.
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#00FDFF"}}> Default Color: #00FDFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[20]</h4>
                                <h3>GameStats_BetterLabelColor</h3>
                                <p>This is the color of the text that says "BETTER!".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[21]</h4>
                                <h3>GameStats_BetterValueColor</h3>
                                <p>This is the color of the text that shows the amount of notes the player hit, and got
                                    a "BETTER" judgement, on.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[22]</h4>
                                <h3>GameStats_DecentHitLabelColor</h3>
                                <p>This is the color of the text that shows the amount of notes the player hit, and got
                                    a "DECENT" judgement, on.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[23]</h4>
                                <h3>GameStats_DecentHitValueColor</h3>
                                <p>This is the color of the text that says "DECENT!".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>


                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[24]</h4>
                                <h3>GameStats_BetterLabelColor</h3>
                                <p>This is the color of the text that says "BETTER!".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[25]</h4>
                                <h3>GameStats_BetterValueColor</h3>
                                <p>This is the color of the text that shows the amount of notes the player hit, and got
                                    a "BETTER" judgement, on.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[26]</h4>
                                <h3>GameStats_MissLabelColor</h3>
                                <p>This is the color of the text that says "MISSES...".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[27]</h4>
                                <h3>GameStats_MissValueColor</h3>
                                <p>This is the color of the text that shows the amount of notes the player hit, and got
                                    a "MISS" judgement, on.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[28]</h4>
                                <h3>Grade_TextColor</h3>
                                <p>This is the color of the Grade you ended with in the level - this is a letter.
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                        <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                        <div className="leftright-textimage-align">
                            <img
                                src={Images.results_menu_layer2}
                                style={{height: "293px", width: "520px"}}
                                alt="Custom Menu.png!"
                            />
                            <div>
                                <h3>Results "Ranking" Types (Layer 2)</h3>
                                <p>Any one of these four rankings could show up when you complete a level.</p>
                            </div>
                        </div>

                        <div className="property-array-align">
                            <div>
                                <h4>[1]</h4>
                                <h3>PassState_MaximumPerfectionBackingColor</h3>
                                <p>This is the color of the shape behind the Maximum Perfection ranking's text.
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#007C91"}}> Default Color: #007C91 </span>
                                </p>
                            </div>
                            <div>
                                <h4>[2]</h4>
                                <h3>PassState_MaximumPerfectionTextColor</h3>
                                <p>This is the color of the text that says "MAXIMUM PERFECTION!!".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[3]</h4>
                                <h3>PassState_FullComboBackingColor</h3>
                                <p>This is the color of the shape behind the Full Combo ranking's text.
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#53039F"}}> Default Color: #53039F </span>
                                </p>
                            </div>
                            <div>
                                <h4>[4]</h4>
                                <h3>PassState_FullComboTextColor</h3>
                                <p>This is the color of the text that says "FULL COMBO?!".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                        <div className="property-array-align">
                            <div>
                                <h4>[5]</h4>
                                <h3>PassState_PassBackingColor</h3>
                                <p>This is the color of the shape behind the Pass ranking's text.
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#960040"}}> Default Color: #960040 </span>
                                </p>
                            </div>
                            <div>
                                <h4>[6]</h4>
                                <h3>PassState_PassTextColor</h3>
                                <p>This is the color of the text that says "MAP CLEARED!".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                            <div>
                                <h4>[7]</h4>
                                <h3>PassState_LoseBackingColor</h3>
                                <p>This is the color of the shape behind the Lose ranking's text.
                                    <br></br>
                                    <span className="dimensionsText"
                                          style={{color: "#C83E00"}}> Default Color: #C83E00 </span>
                                </p>
                            </div>
                            <div>
                                <h4>[8]</h4>
                                <h3>PassState_LoseTextColor</h3>
                                <p>This is the color of the text that says "FAIL.".
                                    <br></br>
                                    <span className="dimensionsText"> Default Color: #FFFFFF </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div id="next-section" className="sectionFormatting">
                        <h2>Next Section: Configurable Sprites</h2>
                        <p>
                            This is a little unknown and still being expanded constantly, but this is a list of all the changeable sprites inside Poly Beats.
                        </p>

                        <Link to="/Tutorial-Archive/Themes/ConfigurableSprites">
                            <button className="fof-menu-button"><span>Configurable Sprites -></span></button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>


    );
}